import {
  Component,
  HostListener,
  Injectable,
  Input,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { CountriesComponent } from '../../shared/countries/countries.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NotificationService } from '@/app/services/notification/notification.service';
import { BxNotification } from '@/app/interfaces/notification.interface';
import { MatListModule } from '@angular/material/list';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { WrapperComponent } from '../../projects/wrapper/wrapper.component';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { User } from '@/app/interfaces/user-info.interface';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { NgToastService } from 'ng-angular-popup';
import { EventBusService } from '@/app/services/shared/event-bus.service';
import { RfiService } from '@/app/services/rfi/rfi.service';
@Component({
  selector: 'app-appHeader',
  standalone: true,
  imports: [
    CommonModule,
    CountriesComponent,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatListModule,
    WrapperComponent,
  ],

  templateUrl: './appHeader.component.html',
  styleUrls: ['./appHeader.component.css'],
})
@Injectable({ providedIn: 'root' })
export class AppHeaderComponent implements OnInit {
  @Input() sidebarOpen = false;
  selectedSection: string;
  isProjectOpen = false;
  isOpen = true;
  isProfileMenuOpen = false;
  notifications: BxNotification[] = [];
  showButton = false;
  showEoiButton = false;
  showProjectTitle = false;
  org_info: any = localStorage.getItem('org_info')
    ? JSON.parse(localStorage.getItem('org_info') as string)
    : null;
  user_info: User = localStorage.getItem('user_info')
    ? JSON.parse(localStorage.getItem('user_info') as string)
    : null;
  project_title: string;
  isToolMenuOpen = false;
  isProjectsMenuOpen = false;
  projects: any;
  projectId: any;
  selectedProject: any;
  requestedprojects: any;
  projectType: string;
  projectIdentifier: string;
  expandedScopeOfWork = true;
  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private sanitizer: DomSanitizer,
    private GetProjectIdService: GetProjectIdService,
    private projectsService: ProjectsService,
    private tenderingService: TenderingService,
    private toast: NgToastService,
    private eventBusService: EventBusService,
    private rfiService: RfiService
  ) {}
  private subscription: Subscription = new Subscription();
  ngOnInit() {
    // Subscribe to router events
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateSelectedSection(event.url);
      }
    });

    this.updateSelectedSection(this.router.url);

    //Recent Notifications//
    this.notificationService.getAllNotifications().subscribe({
      next: (v: any) => {
        if (v && v.data.length > 0) {
          this.notifications = v.data;
        }
      },
    });

    this.subscription = this.GetProjectIdService.projectId$.subscribe(() => {
      this.selectedProject = localStorage.getItem('project-name');
    });
    this.projectId = +this.GetProjectIdService.getProjectId();
    this.getAllProjects();
    this.getRequestedProjects();

    this.eventBusService.projectCreated$.subscribe(() => {
      this.getAllProjects();
    });
  }

  handleDialog() {
    this.isProjectOpen = false;
  }

  private updateSelectedSection(fullUrl: string): void {
    if (fullUrl.includes('tendering/itt')) {
      this.selectedSection = 'RFP';
    } else if (fullUrl.includes('tendering/rfq')) {
      this.selectedSection = 'RFQ';
    } else {
      const match = fullUrl.match(/\/([^/?]+)/);
      if (match && match[1]) {
        this.selectedSection = match[1];
      }
    }
  }

  // Get subject from notifications data
  getSubject(notification: any): SafeHtml {
    if (notification.data) {
      const parsedData = JSON.parse(notification.data);
      return this.sanitizer.bypassSecurityTrustHtml(parsedData.subject);
    }
    return this.sanitizer.bypassSecurityTrustHtml(
      notification.subject || 'No Description Available'
    );
  }

  setIsopen() {
    this.isOpen = !this.isOpen;
  }

  setIsProfileMenuOpen() {
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
    if (this.isProfileMenuOpen) {
      this.isToolMenuOpen = false;
      this.isProjectsMenuOpen = false;
    }
  }
  handleLogOut() {
    localStorage.clear();
    this.router.navigate(['/login']);
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }
  navigateToProfile() {
    this.router.navigate(['/profile']);
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }
  createNewProject() {
    localStorage.removeItem('isEdit');
    localStorage.removeItem('projectId');
    localStorage.setItem('isApproved', String(false));

    const stages = {
      stage1: false,
      stage2: false,
      stage3: false,
    };
    localStorage.setItem('stages', JSON.stringify(stages));
    this.isProjectOpen = true;
    //  this.router.navigate(['/project-stages']);
  }
  navigateTo() {
    this.router.navigate(['/notification']);
  }

  handleToolMenu() {
    this.isToolMenuOpen = !this.isToolMenuOpen;
    this.isProjectsMenuOpen = false;
    this.isProfileMenuOpen = false;
  }
  handleProjectMenu() {
    this.isProjectsMenuOpen = !this.isProjectsMenuOpen;
    this.isToolMenuOpen = false;
    this.isProfileMenuOpen = false;
  }

  redirectPage(path: string, section: string) {
    if (!this.projectId) {
      this.toast.warning('Please select the project first', 'WARNING');
      return;
    }
    if (this.projectType !== 'requested') {
      this.router.navigate([path], { queryParams: { section } });
    }
    this.isToolMenuOpen = false;
    this.isProjectsMenuOpen = false;
    this.isProfileMenuOpen = false;
  }

  redirectToTendering(path: string) {
    if (!this.projectId) {
      this.toast.warning('Please select the project first', 'WARNING');
      return;
    }

    this.router.navigate([path], {
      queryParams: {
        projectName: this.selectedProject,
        projectIdentifier: this.projectIdentifier,
      },
    });

    this.isToolMenuOpen = false;
    this.isProjectsMenuOpen = false;
    this.isProfileMenuOpen = false;
  }

  getAllProjects(): void {
    this.projectsService.getAllProjects().subscribe({
      next: (data) => {
        this.projects = data.data;
        this.projects.forEach((project) => {
          if (
            project?.name === this.selectedProject &&
            this.projectId === project?.id
          ) {
            this.projectIdentifier = project?.project_name_id;
            this.projectType = '';
          }
        });
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  getRequestedProjects(): void {
    this.tenderingService.getProjectsRequested().subscribe({
      next: (data) => {
        this.requestedprojects = data?.data;
        this.requestedprojects.forEach((project) => {
          if (
            project?.name === this.selectedProject &&
            this.projectId === project?.id
          ) {
            this.projectIdentifier = project?.project_name_id;
            this.projectType = 'requested';
          }
        });
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  goToProjects() {
    this.router.navigate(['/projects']);
    localStorage.removeItem('project-name');
    // this.selectedProject = '';
    this.isToolMenuOpen = false;
    this.isProjectsMenuOpen = false;
    this.isProfileMenuOpen = false;
  }

  openProject(project: any) {
    this.projectIdentifier = project?.project_name_id;
    this.projectId = project.id;
    localStorage.setItem('project-name', project.name);
    this.GetProjectIdService.setProjectId(project.id);
    this.selectedProject = project?.name;
    this.projectType = '';
    this.rfiService.loadProjectTypeData();
  }

  openRequestedProject(project: any, type: string) {
    this.projectIdentifier = project?.project_name_id;
    this.projectId = project.id;
    localStorage.setItem('project-name', project.name);
    this.GetProjectIdService.setProjectId(project.id);
    this.selectedProject = project?.name;
    this.projectType = type;
  }

  changeTab(currrentTab: string) {
    if (!this.projectId) {
      this.toast.warning('Please select the project first', 'WARNING');
      return;
    }

    this.isToolMenuOpen = false;
    this.isProjectsMenuOpen = false;
    this.isProfileMenuOpen = false;

    if (this.projectType !== 'requested') {
      if (currrentTab === 'Drawings') {
        this.router.navigate(['/project-design', 'drawing']);
      } else if (currrentTab === 'Specifications') {
        this.router.navigate(['/project-design', 'specifications']);
      } else if (currrentTab === 'Calculations') {
        this.router.navigate(['/project-design', 'calculations']);
      } else if (currrentTab === 'Surveys, Reports and Studies') {
        this.router.navigate(['/project-design', 'surverys_reports_studies']);
      } else if (currrentTab === 'Design Review Reports') {
        this.router.navigate(['/project-design', 'design_review_reports']);
      } else if (currrentTab === 'Permits and Applications') {
        this.router.navigate(['/project-design', 'permits_and_applications']);
      } else if (currrentTab === 'Design Sign Off') {
        this.router.navigate(['/project-design', 'design_signoff']);
      } else if (currrentTab === 'RFI') {
        this.router.navigate(['/project-design', 'r_f_i']);
      }
    }
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: Event): void {
    const targetElement = event.target as HTMLElement;

    // Close the menu if the click happens outside the dropdown and button
    if (
      !targetElement.closest('#dropdown-user') &&
      !targetElement.closest('button[data-dropdown-toggle="dropdown-user"]')
    ) {
      this.isProfileMenuOpen = false;
    }
    // Close the project menu if clicked outside
    if (
      !targetElement.closest('#dropdown-project') && // Ensure to target your project menu
      !targetElement.closest('div[data-dropdown-toggle="dropdown-project"]')
    ) {
      this.isProjectsMenuOpen = false;
    }
  }
  toggleMenu() {
    this.expandedScopeOfWork = !this.expandedScopeOfWork;
  }

  navigateToUserRoleManagement() {
    this.router.navigate(['/user-role-management']);
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }
}
